import barba from '@barba/core';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class{

	constructor(){
        barba.hooks.once((data) => {
            this.init()
        })
        barba.hooks.afterEnter((data) => {
            setTimeout(() => {
                //this.destroy();
                this.init()
            }, 300); 
        });
    }
    init (){
        
        const businessElement = document.querySelector('.p-index__business');
        const introElement = document.querySelector('.p-index__business--intro');

        if(businessElement && introElement){
            const scrollTrigger = {
                trigger: businessElement,
                start: 'top 80%',
                end: 'bottom 20%',
                toggleClass: { targets: introElement, className: 'is-inview' }
            };
            ScrollTrigger.create(scrollTrigger);
        }

        const businessSec = document.querySelectorAll('.p-index__business--sec');
        if(businessSec){
            gsap.utils.toArray(businessSec).forEach((section, i) => {
                section.bg = section.querySelector(".p-index__business--bg"); 
                if (i) {
                    section.bg.style.backgroundPosition = `50% ${-innerHeight / 2}px`;
                    gsap.to(section.bg, {
                        backgroundPosition: `50% ${innerHeight / 2}px`,
                        ease: "none",
                        scrollTrigger: {
                        //markers:true,
                        trigger: section,
                        scrub: .1,
                        }
                    });
                } else {
                    section.bg.style.backgroundPosition = "50% 0px"; 
                    gsap.to(section.bg, {
                        backgroundPosition: `50% ${innerHeight / 2}px`,
                        ease: "none",
                        scrollTrigger: {
                        //markers:true,
                        trigger: section,
                        start: "top top", 
                        end: "bottom top",
                        scrub: true
                        }
                    });
                }
            });
        }

        const companySec = document.querySelectorAll('.p-company__sec');
        if(companySec){
            gsap.utils.toArray(companySec).forEach((section, i) => {
                section.bg = section.querySelector(".p-company__bg"); 
                if (i) {
                    section.bg.style.backgroundPosition = `50% ${-innerHeight / 2}px`;
                    gsap.to(section.bg, {
                        backgroundPosition: `50% ${innerHeight / 2}px`,
                        ease: "none",
                        scrollTrigger: {
                        //markers:true,
                        trigger: section,
                        scrub: .1,
                        }
                    });
                } else {
                    section.bg.style.backgroundPosition = "50% 0px"; 
                    gsap.to(section.bg, {
                        backgroundPosition: `50% ${innerHeight / 2}px`,
                        ease: "none",
                        scrollTrigger: {
                        //markers:true,
                        trigger: section,
                        start: "top top", 
                        end: "bottom top",
                        scrub: true
                        }
                    });
                }
            });
        }
    }
    // destroy() {
    //     ScrollTrigger.getAll().forEach((instance) => {
    //         instance.kill();
    //     });
    // }
}